import Vue from "vue";
import Vuex from "vuex";
import _ from "lodash";
import APIService  from "@/services/api.service";
import { update_feature_count, init_feature_colors } from "./helper";
Vue.use(Vuex);
let check_split_permissions = (treatment) => {
  if (treatment == "on") {
    return true;
  } else if (treatment == "off") {
    return false;
  } else {
    return true;
  }
}
export default new Vuex.Store({
  state: {
    ALLOWED_ROLES: ["hacker", "manager_team"],
    SUPER_USER_ROLES: ["data_team", "bot", "hacker", "manager_team"],
    //
    is_loading: false,
    container: null,
    feature_type_groups: null,
    claims: {},
    current_organization: {},
    token: null,
    authenticated: false,
    map: null,
    draw: null,
    features_count: {},
    active_project: null,
    active_projects: {},
    selected_features: null,
    is_continuous_mode: false,
    edit_mode: false,
    // new
    route_name: "container",
    split_client: null,
    fly_active: true,
    mapstyle: localStorage.getItem("mapstyle") || "satellite",
    
    cluster_items_selected: [],
    features_location_map: {},
    strategix4_token: ""
  },
  mutations: {
    async SET_STRATEGIX4_TOKEN(state) {
      let body = {
        email:
          localStorage.getItem("strategix4_email") || "vijaym@sensehawk.com",
        password:
          localStorage.getItem("strategix4_password") || "Sensehawk@123",
      };
      const apiService = new APIService();
      let response = await apiService.get_strategix4_token({
        body,
      });
      let token = response.data.token;
      state.strategix4_token = token;
      console.log("state.strategix4_token",state.strategix4_token)
    },
    UPDATE_FEATURES_LOCATION_MAP(state, value = []) {
      value.forEach(feature => {
        if (feature.properties.name)
          state.features_location_map[feature.properties.name] = turf.centroid(feature)
      });
      state.features_location_map = { ...state.features_location_map }
      console.log("features_location_map", state.features_location_map)
    },
    SET_CLUSTER_ITEMS_SELECTED(state, value) {
      state.cluster_items_selected = value;
    },
    SET_MAPSTYLE(state, value) {
      state.mapstyle = value
      localStorage.setItem("mapstyle", state.mapstyle);
    },
    TOGGLE_FLY_STATE(state, value) {
      state.fly_active = value;
    },
    SET_SPLIT_CLIENT(state, split_client) {
      state.split_client = split_client;
    },
    SET_ROUTE_NAME(state, route_name) {
      state.route_name = route_name;
    },
    SET_IS_LOADING(state, value) {
      state.is_loading = value;
    },
    SET_EDIT_MODE(state, value) {
      state.edit_mode = value;
    },
    SET_CONTAINER(state, value) {
      state.container = value;
    },
    SET_ACTIVE_PROJECT(state, project) {
      state.active_project = project;
      if (Object.values(state.active_projects).length) {
        for (let layer of Object.values(state.active_projects)) {
          if (
            layer.info &&
            state.map.getLayer("MAPLAYER:" + String(layer.info.uid))
          ) {
            state.map.setLayoutProperty(
              "MAPLAYER:" + String(layer.info.uid),
              "visibility",
              "none"
            );
            state.active_projects[layer.info.uid].is_ortho_active = false;
          }
        }
      }
      // Activate only this active project
      if (
        state.active_projects[state.active_project.uid] &&
        state.map.getLayer("MAPLAYER:" + String(state.active_project.uid))
      ) {
        state.map.setLayoutProperty(
          "MAPLAYER:" + String(state.active_project.uid),
          "visibility",
          "visible"
        );
        state.active_projects[state.active_project.uid].is_ortho_active = true;
      }
      state.active_projects = { ...state.active_projects }
    },
    UPDATE_ACTIVE_PROJECTS(state, data) {
      state.active_projects[data.layer.uid] = data.payload;
      state.active_projects = { ...state.active_projects }

      update_feature_count(state);
    },
    FILTER_FEATURES_BY_PROJECT(state, data) {
      let { project, active } = data;

      if (state.active_projects[project.uid].is_feature_active == active) return



      state.active_projects[project.uid].is_feature_active = active;
      if (state.active_projects[project.uid].is_feature_active) {
        let to_add = _.remove(
          state.active_projects[project.uid].filtered_features,
          feature => feature.properties.project === project.uid
        );
        state.draw.add({ type: "FeatureCollection", features: to_add });
      } else {
        let to_remove = _.filter(
          state.draw.getAll().features,
          feature => feature.properties.project === project.uid
        );
        let filtered_featureIds = _.map(to_remove, feature => feature.id);
        state.draw.delete(filtered_featureIds);
        if (state.active_projects[project.uid].filtered_features)
          state.active_projects[project.uid].filtered_features.push(
            ...to_remove
          );
      }
      update_feature_count(state);
    },
    FILTER_FEATURES_BY_CLASS(state, data) {
      try {
        let { class_id, active } = data;
        for (let layer of Object.values(state.active_projects)) {
          // state.active_projects[layer.info.uid].is_feature_active = active;
          if (layer.info && state.active_projects[layer.info.uid].is_feature_active && active) {
            let to_add = _.remove(
              state.active_projects[layer.info.uid].filtered_features,
              feature =>
                feature.properties.featureTypeId === class_id &&
                feature.properties.project === layer.info.uid
            );
            state.draw.add({ type: "FeatureCollection", features: to_add });
          } else {
            let to_remove = _.filter(
              state.draw.getAll().features,
              feature =>
                feature.properties.featureTypeId === class_id &&
                feature.properties.project === layer.info.uid
            );
            let filtered_featureIds = _.map(to_remove, feature => feature.id);
            state.draw.delete(filtered_featureIds);
            state.active_projects[layer.info.uid].filtered_features.push(
              ...to_remove
            );
          }
        }
        state.draw.set(state.draw.getAll())
        update_feature_count(state);
      } catch (err) {
        console.log(err)
      }
    },
    FILTER_FEATURES_BY_EXTRAPROPS(state, filter) {
      for (let layer of Object.values(state.active_projects)) {
        if (layer.is_feature_active) {
          if (filter.values.length) {
            let to_add = _.remove(
              state.active_projects[layer.info.uid].epff || [],
              feature =>
                feature.properties.project === layer.info.uid &&
                feature.properties.extraProperties &&
                _.includes(
                  filter.values,
                  feature.properties.extraProperties[filter.key]
                )
            );
            state.draw.add({ type: "FeatureCollection", features: to_add });
            // } else {
            let to_remove = _.filter(
              state.draw.getAll().features,
              feature =>
                feature.properties.project === layer.info.uid &&
                (!feature.properties.extraProperties ||
                  !_.includes(
                    filter.values,
                    feature.properties.extraProperties[filter.key]
                  ))
            );
            let filtered_featureIds = _.map(to_remove, feature => feature.id);
            state.draw.delete(filtered_featureIds);
            if (!state.active_projects[layer.info.uid].epff)
              state.active_projects[layer.info.uid].epff = [];
            state.active_projects[layer.info.uid].epff.push(...to_remove);
          } else {
            state.draw.add({
              type: "FeatureCollection",
              features: state.active_projects[layer.info.uid].epff || []
            });
          }
        }
      }
      update_feature_count(state);
    },
    UPDATE_FEATURE_COUNT(state) {
      update_feature_count(state);
    },
    SET_SELECTED_FEATURES(state, features) {
      state.selected_features = features;
    },
    SET_AUTHENTICATED(state, value) {
      state.authenticated = value;
    },
    SET_TOKEN(state, value) {

      let org = window.$cookies.get("user_organization");
      if (org)
        org = JSON.parse(atob(org));
      this.current_organization = org;

      if (value) {
        state.token = "jwt " + value;
        // state.claims = jwt_decode(value)

        // setting for guest user
        // let claims = jwt_decode(value);
        // state.claims = claims;

        // let current_org;

        // const user_role = claims.user_role || {};
        // const is_internal_user = _.includes(
        //   state.ALLOWED_ROLES,
        //   user_role.name
        // );
        // let cookies_organization = window.$cookies.get("user_organization");
        // if (cookies_organization)
        //   cookies_organization = JSON.parse(atob(cookies_organization));

        // user is internal and organization cookies exists
        // if (is_internal_user) {
        //   current_org = cookies_organization || { uid: "", name: "All" };
        // }
        // user has guest organizations access
        // else if (claims.guest_organizations.length) {
        // organization cookies exists and its not the user_organization
        // if (
        // cookies_organization &&
        // cookies_organization.uid !== claims.user_organization.uid
        // ) {
        // check if cookies_organization is from guest_organizations list
        // let guest_organization = claims.guest_organizations.find(
        // o => o.uid === cookies_organization.uid
        // );
        // if not from guest_organizations list
        // if (!guest_organization) {
        // current_org = claims.user_organization;
        // } else {
        // set claims persmission, teams, label etc from guest_organization
        // state.claims = {
        // ...claims,
        // app_permissions: guest_organization.app_permissions,
        // labels: guest_organization.labels,
        // is_manager: false,
        // is_owner: false
        // };
        // current_org = {
        // name: guest_organization.name,
        // uid: guest_organization.uid
        // };
        // }
        // } else {
        // current_org = claims.user_organization;
        // }
        // }
        // user is not internal and no organization cookies exists
        // else {
        // current_org = claims.user_organization || {};
        // }

        // finally update the state and cookies
        // state.current_organization = current_org;
      }
    },
    SET_CLAIMS(state, value) {
      if (!value) return;

      state.claims = value;
      // setting for guest user
      let claims = { ...state.claims };

      let current_org;

      const user_role = claims.user_role || {};
      const is_internal_user = _.includes(
        state.ALLOWED_ROLES,
        user_role.name
      );
      let cookies_organization = window.$cookies.get("user_organization");
      if (cookies_organization)
        cookies_organization = JSON.parse(atob(cookies_organization));

      // user is internal and organization cookies exists
      if (is_internal_user) {
        current_org = cookies_organization;
      }
      // user has guest organizations access
      else if (claims.guest_organizations.length && !claims.user_organization) {
        // organization cookies exists and its not the user_organization
        if (
          cookies_organization &&
          cookies_organization.uid !== claims.user_organization.uid
        ) {
          // check if cookies_organization is from guest_organizations list
          let guest_organization = claims.guest_organizations.find(
            o => o.uid === cookies_organization.uid
          );
          // if not from guest_organizations list
          if (!guest_organization) {
            current_org = claims.user_organization;
          } else {
            // set claims persmission, teams, label etc from guest_organization
            state.claims = {
              ...claims,
              app_permissions: guest_organization.app_permissions,
              labels: guest_organization.labels,
              is_manager: false,
              is_owner: false
            };
            current_org = {
              name: guest_organization.name,
              uid: guest_organization.uid
            };
          }
        } else {
          current_org = claims.user_organization;
        }
      }
      // user is not internal and no organization cookies exists
      else {
        current_org = claims.user_organization || {};
      }
      // finally update the state and cookies
      state.current_organization = current_org;
    },
    INIT_MAP(state, map) {
      state.map = map;
    },
    INIT_DRAW(state, draw) {
      state.draw = draw;
    },
    INIT_FEATURE_COLORS(state) {
      init_feature_colors(state);
    },
    SET_DRAW_MODE(state, mode) {
      state.draw_mode = mode;
    },
    TOGGLE_CONTINUOUS_MODE(state) {
      state.is_continuous_mode = !state.is_continuous_mode;
    },
    SET_FEATURE_TYPE_GROUPS(state, value) {
      state.feature_type_groups = value;
      // Init features count
      for (let featureTypegroup of state.feature_type_groups) {
        for (let featureType of featureTypegroup.featureTypes) {
          state.features_count[featureType.id] = {
            count: 0,
            class_id: featureType.id
          };
        }
      }
    }
  },
  getters: {
    has_modify_feautes_type_permissions(state) {
      if (state.claims) {
        return (
          (state.claims.app_permissions &&
            state.claims.app_permissions.terra &&
            state.claims.app_permissions.terra.length &&
            _.includes(
              state.claims.app_permissions.terra,
              "modify_feature_types"
            )) ||
          (state.claims.user_role &&
            _.includes(state.SUPER_USER_ROLES, state.claims.user_role.name))
        );
      }
      return false;
    },
    has_tickets_app_access(state) {
      if (state.claims) {
        return (
          state.claims.app_permissions && state.claims.app_permissions.tickets
        );
      }
      return false;
    },
    has_vault_app_access(state) {
      if (state.claims) {
        return (
          state.claims.app_permissions && state.claims.app_permissions.vault
        );
      }
      return false;
    },
    // Split permissions
    debug(state) {
      if (state.split_client && state.claims) {
        return check_split_permissions(state.split_client.getTreatment("debug", state.claims));
      }
      return false;
    },
    localization(state) {
      if (state.split_client) {
        return check_split_permissions(state.split_client.getTreatment("localization", state.claims))
      }
    },
    show_feature_labels(state) {
      if (state.split_client) {
        return check_split_permissions(state.split_client.getTreatment("show_feature_labels", state.claims))
      }
    },
    forms(state) {
      if (state.split_client) {
        return check_split_permissions(state.split_client.getTreatment("forms", state.claims))
      }
    },
    enable_fullstory(state) {
      if (state.split_client) {
        return check_split_permissions(state.split_client.getTreatment("enable_fullstory", state.claims))
      }
    },
    tickets_clustering(state) {
      if (state.split_client && state.claims) {
        return check_split_permissions(
          state.split_client.getTreatment("tickets_clustering", state.claims)
        );
      }
      return false;
    },
  }
});
